export default __webpack_public_path__ + "static/media/DG.463fa779.jpeg";